"use client";

import dynamic from "next/dynamic";
import type { SiteRendererProps } from "@locusly/client-runtime";

// ssr: false prevents framer-motion's react-server stub from being loaded
// during Next.js SSR, which causes __webpack_modules__[moduleId] is not a function
const WeddingApp = dynamic(() => import("../src/App"), { ssr: false });

export default function WeddingInvitationRenderer({
  content,
  editing,
  publicWriteToken,
  tenantId,
  routePath,
}: SiteRendererProps) {
  return (
    <WeddingApp
      content={content}
      editing={editing}
      tenantId={tenantId}
      publicWriteToken={publicWriteToken}
      routePath={routePath}
      useExternalEditMode
    />
  );
}
